/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { Col, Container, Row, Card } from 'react-bootstrap';
import { ClientErrorSVG } from '../img/ClientErrorSVG';
import './error.scss';

const CustomClientError = ({
  ErrorHeading,
  ErrorMessage,
  CustomClasses = null,
  className,
  disableMailTo,
  showWidth = true,
}) => {
  return (
    <div>
      <Container fluid className={CustomClasses}>
        <Card className="mt-3 mb-3 p-5 card border-light">
          <div className="mtop30 logout">
            <Row className="h-100">
              <Col className="my-auto error-container">
                <ClientErrorSVG
                  className="client-error-mark"
                  parentClassName="clienterrorsvg"
                  circleClass="error-circle"
                />

                <Row
                  className={`${
                    showWidth ? 'w-60' : 'w-80'
                  } mx-auto error-msg ${className}`}
                >
                  <Col>
                    <h1 role="alert">{ErrorHeading}</h1>
                    <p role="alert">
                      {ErrorMessage}
                      {/*{ !disableMailTo &&
                        <a href="mailto:tpacustomerservice@keenan.com">
                          mailto:tpacustomerservice@keenan.com
                        </a> } */}
                    </p>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </Card>
      </Container>
    </div>
  );
};

export default CustomClientError;
